(function(){
  function initRepairBundle(bundle){
    if(!bundle || bundle.dataset.initialized === 'true') return;
    bundle.dataset.initialized = 'true';

    var itemChecks = bundle.querySelectorAll('[data-repair-item], [data-protection-item]');
    var protectionCheck = bundle.querySelector('[data-protection-item]');
    var protectionPrice = bundle.querySelector('[data-protection-price]');
    var modal = bundle.querySelector('[data-protection-modal]');
    var detailsButton = bundle.querySelector('[data-protection-details]');

    function getProductScope(){
      return bundle.closest('.product-info') || bundle.closest('[id^="shopify-section"]') || document;
    }

    function getProductForm(){
      var scope = getProductScope();
      var form = scope.querySelector('form[data-type="add-to-cart-form"]') || scope.querySelector('product-form form[action*="/cart/add"]');
      if(form) return form;

      var addButton = scope.querySelector('button[name="add"], .button-add-to-cart, .product-form__submit');
      if(addButton && addButton.form) return addButton.form;

      return document.querySelector('form[data-type="add-to-cart-form"]') || document.querySelector('product-form form[action*="/cart/add"]');
    }

    function getSubmitButtons(){
      var productForm = getProductForm();
      if(productForm){
        var buttons = Array.prototype.slice.call(productForm.querySelectorAll('button[type="submit"], button[name="add"], .button-add-to-cart, .product-form__submit'));
        if(buttons.length) return buttons.filter(function(btn){ return !bundle.contains(btn); });
      }

      var scope = getProductScope();
      var fallback = Array.prototype.slice.call(scope.querySelectorAll('button[name="add"], .button-add-to-cart, .product-form__submit'));
      if(!fallback.length){
        fallback = Array.prototype.slice.call(document.querySelectorAll('button[name="add"], .button-add-to-cart, .product-form__submit'));
      }
      return fallback.filter(function(btn){ return !bundle.contains(btn); });
    }

    function selectedCount(){
      var count = 0;
      itemChecks.forEach(function(check){ if(check.checked) count++; });
      return count;
    }

    function setButtonLabel(button, text){
      if(!button) return;
      var preferred = button.querySelector('[data-button-text], [data-add-to-cart-text], .button__text');
      if(preferred){
        preferred.textContent = text;
        return;
      }

      var childSpans = button.querySelectorAll('span');
      for(var i = 0; i < childSpans.length; i++){
        var spanText = childSpans[i].textContent.trim().toLowerCase();
        if(spanText.indexOf('add to cart') !== -1 || spanText.indexOf('add ') === 0){
          childSpans[i].textContent = text;
          return;
        }
      }

      var textNode = null;
      for(var j = 0; j < button.childNodes.length; j++){
        var node = button.childNodes[j];
        if(node.nodeType === 3 && node.textContent.trim()){
          textNode = node;
          break;
        }
      }
      if(textNode) textNode.textContent = text;
      else button.textContent = text;
    }

    function updateButton(){
      var selected = selectedCount();
      var text = selected ? ('Add ' + (selected + 1) + ' to Cart') : 'Add to cart';
      getSubmitButtons().forEach(function(button){ setButtonLabel(button, text); });
    }

    itemChecks.forEach(function(check){
      check.addEventListener('change', updateButton);
    });

    bundle.querySelectorAll('.repair-bundle__item').forEach(function(row){
      row.addEventListener('click', function(event){
        if(event.target.closest('input, select, button, a, label')) return;
        var check = row.querySelector('.repair-bundle__checkbox');
        if(!check) return;
        check.checked = !check.checked;
        check.dispatchEvent(new Event('change', {bubbles:true}));
      });
    });

    function openModal(event){
      if(event){ event.preventDefault(); event.stopPropagation(); }
      if(!modal) return;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    function closeModal(){
      if(!modal) return;
      modal.hidden = true;
      document.body.style.overflow = '';
    }
    if(detailsButton) detailsButton.addEventListener('click', openModal);
    if(modal){
      document.body.appendChild(modal);
      modal.querySelectorAll('[data-protection-close]').forEach(function(el){ el.addEventListener('click', closeModal); });
      document.addEventListener('keydown', function(event){ if(event.key === 'Escape' && !modal.hidden) closeModal(); });
    }

    function syncProtectionTier(){
      var productForm = getProductForm();
      if(!productForm || !protectionCheck) return;
      var idInput = productForm.querySelector('[name="id"]');
      if(!idInput) return;
      var tier = bundle.querySelector('[data-protection-tier][data-glass-variant-id="' + idInput.value + '"]');
      if(!tier) return;
      protectionCheck.dataset.variantId = tier.dataset.protectionVariantId;
      protectionCheck.dataset.protectedSku = tier.dataset.glassSku || '';
      protectionCheck.dataset.glassPrice = tier.dataset.glassPrice || '';
      if(protectionPrice) protectionPrice.textContent = tier.dataset.protectionPrice || '';
    }
    syncProtectionTier();

    var productScope = getProductScope();
    if(productScope && productScope !== document){
      productScope.addEventListener('change', function(){ setTimeout(syncProtectionTier,0); });
    }

    var productForm = getProductForm();
    if(productForm){
      productForm.addEventListener('submit', function(event){
        var selected = Array.prototype.filter.call(itemChecks, function(check){ return check.checked; });
        if(!selected.length) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        syncProtectionTier();

        var idInput = productForm.querySelector('[name="id"]');
        var qtyInput = productForm.querySelector('[name="quantity"]');
        if(!idInput) return;

        var mainQuantity = qtyInput ? Number(qtyInput.value || 1) : 1;
        if(!mainQuantity || mainQuantity < 1) mainQuantity = 1;
        var items = [{id:Number(idInput.value), quantity:mainQuantity}];

        selected.forEach(function(check){
          var variantId = check.dataset.variantId;
          if(!variantId){
            var row = check.closest('.repair-bundle__item');
            var select = row ? row.querySelector('[data-repair-variant]') : null;
            if(select) variantId = select.value;
          }
          if(!variantId) return;

          var item = {id:Number(variantId), quantity:1};
          if(check.hasAttribute('data-protection-item')){
            item.properties = {
              '_Protected Product': bundle.dataset.protectedProduct || '',
              '_Protected SKU': check.dataset.protectedSku || '',
              '_Glass Purchase Price': check.dataset.glassPrice || '',
              '_Protection Term': '2 Years',
              '_Protected Variant ID': idInput.value
            };
          }
          items.push(item);
        });

        var submitButtons = getSubmitButtons();
        var submitButton = submitButtons.length ? submitButtons[0] : null;
        submitButtons.forEach(function(button){ button.disabled = true; });

        var minicart = document.querySelector('mini-cart');
        var payload = {items:items};
        if(minicart && typeof minicart.getSectionsToRender === 'function'){
          payload.sections = minicart.getSectionsToRender().map(function(section){ return section.section; });
          payload.sections_url = window.location.pathname;
        }

        fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method:'POST',
          headers:{
            'Content-Type':'application/json',
            'Accept':'application/json',
            'X-Requested-With':'XMLHttpRequest'
          },
          body:JSON.stringify(payload)
        }).then(function(response){
          return response.json().then(function(data){
            if(!response.ok || data.status) throw data;
            return data;
          });
        }).then(function(response){
          if(minicart && typeof minicart.renderContents === 'function'){
            minicart.renderContents(response);

            if(window.themeSettings && window.themeSettings.redirectToCart){
              window.location.href = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
              return;
            }

            if(typeof minicart.open === 'function') minicart.open(submitButton);
          } else {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            var cartDrawer = document.querySelector('cart-drawer, [data-cart-drawer]');
            if(cartDrawer && typeof cartDrawer.open === 'function') cartDrawer.open();
            else {
              var cartTrigger = document.querySelector('[data-cart-toggle], [href="#mini-cart"], [aria-controls*="cart" i]');
              if(cartTrigger) cartTrigger.click();
              else window.location.href = '/cart';
            }
          }

          var addedItems = response.items || [response];
          var context = productForm.dataset.eventContext;
          document.dispatchEvent(new CustomEvent('cart:item-add', {
            detail:{items:addedItems, context:context}
          }));

          if(typeof publish === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartItemAdd){
            publish(PUB_SUB_EVENTS.cartItemAdd, {
              source:context,
              items:addedItems
            });
          }
        }).catch(function(error){
          console.error('Complete Your Repair add-to-cart error:', error);
          alert((error && error.description) ? error.description : 'We could not add the selected items. Please try again.');
        }).finally(function(){
          submitButtons.forEach(function(button){ button.disabled = false; });
          updateButton();
        });
      }, true);
    }

    updateButton();
    setTimeout(updateButton, 250);
  }

  function initAll(){ document.querySelectorAll('[data-repair-bundle]').forEach(initRepairBundle); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();